import { render, staticRenderFns } from "./AdvDetail.vue?vue&type=template&id=aa03f810&scoped=true"
import script from "./AdvDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdvDetail.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa03f810",
  null
  
)

export default component.exports